import React from 'react';
import PropTypes from 'prop-types';

const Upload = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <path fill="none" d="M0,0h24v24H0V0z" />
      <g id="upload" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
        <path d="M18.125,10.3666667 C17.5583333,7.49166667 15.0333333,5.33333333 12,5.33333333 C9.59166667,5.33333333 7.5,6.7 6.45833333,8.7 C3.95,8.96666667 2,11.0916667 2,13.6666667 C2,16.425 4.24166667,18.6666667 7,18.6666667 L17.8333333,18.6666667 C20.1333333,18.6666667 22,16.8 22,14.5 C22,12.3 20.2916667,10.5166667 18.125,10.3666667 Z M13.6666667,12.8333333 L13.6666667,16.1666667 L10.3333333,16.1666667 L10.3333333,12.8333333 L7.83333333,12.8333333 L12,8.66666667 L16.1666667,12.8333333 L13.6666667,12.8333333 Z" id="Shape" fill={color} fillRule="nonzero"></path>
      </g>
    </svg>
  );
}

Upload.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Upload.defaultProps = {
  color: '#000000',
  width: 24,
  height: 24,
};

export default Upload;



// WEBPACK FOOTER //
// ./src/components/Icons/Upload.jsx